import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchSignNowEnvelopeStatusMutation,
  Flex_FetchSignNowEnvelopeStatusMutationVariables,
} from '~/typings/graphql';
import { SignNowEnvelopeStatus } from '~/typings/signnow';
import { FETCH_SIGN_NOW_ENVELOPE_STATUS } from './check-ipa-signature-status.queries';

interface CheckIpaSignatureStatusParams {
  envelopeId: number;
}

export interface CheckIpaSignatureStatusResponse {
  status: SignNowEnvelopeStatus;
  envelope: {
    id: number;
    url?: string | null;
  };
}

export const checkIpaSignatureStatus = async (
  params: CheckIpaSignatureStatusParams,
): Promise<CheckIpaSignatureStatusResponse> => {
  const { data } = await apolloClient.mutate<
    Flex_FetchSignNowEnvelopeStatusMutation,
    Flex_FetchSignNowEnvelopeStatusMutationVariables
  >({
    mutation: FETCH_SIGN_NOW_ENVELOPE_STATUS,
    variables: {
      id: params.envelopeId,
    },
  });

  if (!data?.fetchSignNowEnvelopeStatus) {
    throw new Error('Failed to fetch SignNow envelope status');
  }

  const envelope = data.fetchSignNowEnvelopeStatus;

  return {
    status: envelope.status as SignNowEnvelopeStatus,
    envelope: {
      id: envelope.id,
      url: envelope.signingUrl,
    },
  };
};
